export enum Roles {
  ADMINISTRATOR = 'Administrator',
  SUPER_ADMIN = 'SuperAdmin',
  EMPLOYEE = 'Employee',
  USER = 'User',
  PM = 'Pm',
  HRM = 'HRM',
}

export enum StorageVariables {
  ME = 'me',
  TOKEN = 'token',
  THEME = 'theme',
  LANGUAGE = 'language',
  PROJECT_ID = 'projectId',
  DEPARTMENT = 'department',
  EMPLOYEE_ID = 'employeeId',
  ASIDE_STATE = 'aside_state',
  RESEND_TIMER = 'resend_timer',
  CURRENT_COMPANY = 'currentCompany',
  KPI_CUSTOMER_EMAIL = 'kpiCustomerEmail',
  CURRENT_EMPLOYEE_TAB = 'currentEmployeeTab',
}

export enum ModalResponse {
  SUCCESS = 'success',
  CANCEL = 'cancel',
  ERROR = 'error',
}
export class ActionConstants {
  public static readonly ACTION_ADD = 'add';
  public static readonly ACTION_VIEW = 'view';
  public static readonly ACTION_EDIT = 'edit';
  public static readonly ACTION_DELETE = 'delete';
}

export enum ApiVersions {
  V1 = 'v1',
  V1_1 = 'v1.1',
  V2 = 'v2',
  V3 = 'v3',
  V4 = 'v4',
}

export enum IdentifierClaims {
  NAME_IDENTIFIER_CLAIM = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
  ROLE_IDENTIFIER_CLAIM = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
  EMAIL_IDENTIFIER_CLAIM = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
}

export enum DEPARTMENTS {
  ADMINISTRATOR = 'ADMINISTRATOR',
  HRM = 'HRM',
  PM = 'PM',
}

export enum DOWNLOAD_EXTENSION {
  EXCEL = '.xlsx',
}
